import {SearchOutlined} from '@ant-design/icons'
import {Input} from 'antd'
import {useEffect, useState} from 'react'

const LOADING_MIN_INTERVAL = 200

interface SearchInputProps {
    value?: string
    onChange: (value?: string) => void
    placeholder?: string
    width?: string
}

export const SearchInput = ({value, onChange, placeholder, width}:SearchInputProps) => {
    const [timeoutId, setTimeoutId] = useState<any>(undefined)
    const [search, setSearch] = useState<string|undefined>(value)

    function doSearch(newValue?: string) {
        if (timeoutId) {
            clearTimeout(timeoutId)
        }
        setSearch(newValue)
        setTimeoutId(setTimeout(() => {
            setTimeoutId(undefined)
            onChange(newValue)
        }, LOADING_MIN_INTERVAL))
    }

    useEffect(() => {
        if (value !== search) {
            setSearch(value)
            }
    }, [value])

    return <Input
        size="middle"
        prefix={<SearchOutlined/>}
        placeholder={placeholder ? placeholder :'Search by ID, Name'}
        style={{width: width ? width : '200px'}}
        allowClear
        value={search}
        onChange={(e) => doSearch(e.target.value)}
        onPressEnter={(e) => onChange(e.currentTarget.value)}
        onKeyDown={(event) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                setSearch(undefined)
                onChange(undefined)
            }
        }}
        onClear={() => {
            setSearch(undefined)
            onChange(undefined)
        }}
    />
}